import Alert from 'react-bootstrap/Alert'

function Error({ error }) {
  return (
    <Alert className='alert-danger-light'>
      <Alert.Heading>Something went wrong!</Alert.Heading>
      <p className='mb-0'>{error.message}</p>
    </Alert>
  )
}

export default Error
